'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

export function DatadogInit() {
  useEffect(() => {
    if (datadogRum.getInitConfiguration()) return;

    const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
    const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
    if (!applicationId || !clientToken) return;

    const vercelEnv = process.env.NEXT_PUBLIC_VERCEL_ENV;
    const env =
      process.env.NEXT_PUBLIC_DATADOG_ENV ??
      (vercelEnv === 'production'
        ? 'prod'
        : vercelEnv === 'preview'
          ? 'preview'
          : 'dev');

    const version =
      process.env.NEXT_PUBLIC_DATADOG_VERSION ??
      process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA?.slice(0, 7) ??
      'local';

    datadogRum.init({
      applicationId,
      clientToken,
      site: process.env.NEXT_PUBLIC_DATADOG_SITE ?? 'datadoghq.eu',
      service: process.env.NEXT_PUBLIC_DATADOG_SERVICE ?? 'fitvent-web',
      env,
      version,
      sessionSampleRate: 100,
      // Session replay is expensive: it captures every DOM mutation and
      // interaction for every recorded session. 100% sampling on a public
      // event page is overkill - we keep basic RUM (sessionSampleRate) at
      // 100% for the full funnel + error picture, but only replay one in
      // ten sessions so we still have rich recordings to debug from
      // without burning the cold-load budget on every visitor.
      sessionReplaySampleRate: 10,
      trackResources: true,
      trackUserInteractions: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      // iOS Safari blocks the default session cookie under ITP because the
      // Datadog intake is cross-site relative to fitvent.com. Partitioned
      // cookies (CHIPS) are the supported workaround on iOS 16.4+ and let
      // session replay start on mobile Safari.
      usePartitionedCrossSiteSessionCookie: true,
      // Smaller intake payloads - matters most on slow mobile uplinks where
      // unreliable POSTs were dropping replay segments mid-session.
      compressIntakeRequests: true,
      plugins: [reactPlugin({ router: false })],
    });
  }, []);

  return null;
}
